import { FC } from 'react'
import styled from 'styled-components'
import Tooltip from './ToolTip'

type OptionButtonProps = {
  onClick: () => void
  tooltipText: string
}

const Button = styled.button`
  background-color: transparent;
  border: none;
  width: 32px;
  height: 32px;
  cursor: pointer;
`

const dotsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
  </svg>
)
export const OptionButton: FC<OptionButtonProps> = ({ onClick, tooltipText }) => {
  return (
    <Tooltip text={tooltipText} position="left">
      <Button type="button" onClick={onClick}>{dotsIcon}</Button>
    </Tooltip>
  )
}